var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c("app-crm-edit", {
        attrs: { state: _vm.state },
        on: {
          cancel: function ($event) {
            return _vm.onCancel()
          },
          save: function ($event) {
            return _vm.onSave($event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }